
import { computed, defineComponent, reactive, watch } from 'vue'
import Item from './Item.vue'
import Logo from './Logo.vue'
// import variables from '@/assets/styles/variables.styl'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { permissionRoutes } from '@/router/index'

export default defineComponent({
  components: {
    Item,
    Logo
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const sidebar = computed(() => {
      return store.state.app.sidebar
    })
    let routes = computed(() => {
        return store.state.permission.routes
    })
    const showLogo = computed(() => {
        return true
    //   return store.state.settings.showSidebarLogo
    })

    const menuActiveTextColor = computed(() => {
    //   console.log(store.state.settings.sidebarTextTheme)

    //   if (store.state.settings.sidebarTextTheme) {
    //     return '#57CAEB'
    //     // return store.state.settings.theme
    //   } else {
    //     return variables.menuActiveText
    //   }
    })

    const activeMenu = computed(() => {
      const { meta, path } = route
      if (meta !== null || meta !== undefined) {
        if (meta.activeMenu) {
          return meta.activeMenu
        }
      }
      return path
    })

    const isCollapse = computed(() => {
        return sidebar.value.opened
    })

    watch(() => store.state.permission.routes, () => {
        routes = store.state.permission.routes
    })

    return {
      sidebar,
      routes,
      showLogo,
      menuActiveTextColor,
    //   variables,
      activeMenu,
      isCollapse
    }
  }
})
